import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export const AdminViewToggle = ({ adminViewMode, setAdminViewMode }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, gap: 2 }}>
      <Button
        variant="contained"
        onClick={() => setAdminViewMode(adminViewMode === "form" ? "details" : "form")}
        sx={{ backgroundColor: "#29474d" }}
      >
        {adminViewMode === "form" ? t("viewDetails") : t("backToForm")}
      </Button>
    </Box>
  );
};
